import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const RefreshIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className || "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M12.285 4.862c-.85-.68-1.883-1.22-3.128-1.22a5.357 5.357 0 1 0 5.046 7.162c.133-.372.508-.62.894-.539l.698.148c.386.082.636.463.518.84A7.5 7.5 0 1 1 9.157 1.5c1.988-.001 3.537.905 4.651 1.838l1.273-1.273a.714.714 0 0 1 1.22.505V6.5c0 .394-.32.714-.715.714h-3.929a.714.714 0 0 1-.505-1.22z"
      ></path>
    </svg>
  );
};

export default RefreshIcon;
